import SashiDo from 'lib/SashiDo';
import DashboardView   from 'dashboard/DashboardView.react';
import Toolbar         from 'components/Toolbar/Toolbar.react';
import Icon            from 'components/Icon/Icon.react';
import React           from 'react';
import AppsManager     from 'lib/AppsManager';
import moment from 'moment';
import * as formatter from 'lib/formatter';
import { sortObject } from 'lib/helpers';
import { Decimal } from 'decimal.js';

import Tooltip from 'react-autotip';

import Fieldset from 'components/Fieldset/Fieldset.react';
import PreLoader from 'components/PreLoader/PreLoader.react';


import LinkToBack from 'components/LinkToBack/LinkToBack.react';

import settingsStyles from 'dashboard/Settings/Settings.scss';

import stylesButton from 'components/Button/Button.scss';
import styles from './Engine.scss';

import stylesBilling from 'dashboard/Billing/Billing.scss';
import stylesEngine from 'dashboard/Runtime/EngineView.scss';

export default class EngineDetails extends DashboardView {
  constructor(props) {
    super(props);

    this.section = 'Metrics'
    this.subsection = 'Engine'

    this.state = {
      loading: true,
    };
  }

  async componentDidMount() {
    const newStats = await SashiDo.getAppsBillingStatsEngines({ appId: this.context.currentApp.id});
    const { engines, total } = newStats[this.context.currentApp.region];

    this.setState({
      appStats: engines,
      totalPrice: total,
      loading: false,
    });
  }

  renderEngine() {
    const { appStats } = this.state;

    const result = appStats.map((key, i) => {
      return (
        <div key={key.productName} className={[styles.box, styles.table, styles.appDetails].join(' ')}>
          <h2>{key.productName}</h2>

          <div className={styles.customBox}>
            <div className={styles.tableRow}>
              <div>Engine</div>
              <div>Hours</div>
              <div>Start</div>
              <div>End</div>
              <div>Price <span className={stylesBilling.starRed}>*</span><span className={stylesEngine.starBlue}>*</span></div>
            </div>

            {
              key.containers.map((item, i) => {
                const p = new Decimal(item.price).toFixed(3).toString().split('.');

                return (
                  <div key={`${key.productName}-${i}`} className={[styles.usageRow].join(' ')}>
                    <div className={styles.usageColumn}>
                      {
                        item.isActive
                          ? <Tooltip
                              text={'Active Engine'}
                              tooltipStyles={{
                                color: '#fff',
                                fontFamily: 'Ubuntu',
                                fontSize: 14,
                                fontWeigt: 300,
                                borderRadius: 4,
                                maxWidth: 500,
                                width: 140,
                                unit: 4,
                                lightgrey: '#222933',
                                opaqueGrey: '#222933',
                              }}>
                                <div className={styles.usageValue}>
                                  <div className={styles.greenDot}></div>
                                  {item.id}
                                </div>
                            </Tooltip>
                          : <div className={styles.usageValue}>
                              {item.id}
                            </div>
                      }
                    </div>
                    <div className={styles.usageColumn}>
                      <div className={styles.usageValue}>
                        {item.hours}
                      </div>
                    </div>
                    <div className={styles.usageColumn}>
                      <div className={[styles.usageValue, styles.date].join(' ')}>
                        {moment(item.from).format('MMM DD YYYY HH:mm')}
                      </div>
                    </div>
                    <div className={styles.usageColumn}>
                      <div className={[styles.usageValue, styles.date].join(' ')}>
                        {
                          item.isActive
                            ? '-'
                            : moment(item.to).format('MMM DD YYYY HH:mm')}
                      </div>
                    </div>
                    <div className={styles.usageColumn}>
                      <div className={styles.price}>
                        <em>$</em>{p[0]}<span>.{p[1]}</span>
                      </div>
                    </div>

                    {
                      // item.isCurrent &&
                      //   <div className={styles.currentRow}>
                      //     Current Engine
                      //   </div>
                    }
                  </div>
                );
              })
            }
          </div>
        </div>
      );
    });

    return result;
  }

  renderContent() {
    const { appStats, totalPrice } = this.state;

    if(!appStats && !totalPrice) {
      return null;
    }

    const classes = [settingsStyles.settings_page, settingsStyles.default];

    const p = new Decimal(totalPrice).toFixed(3).toString().split('.');

    return (
      <div className={classes.join(' ')}>
        <Toolbar section={this.section} subsection="Engine">
          <LinkToBack
            className={stylesButton.button}
            defaultback={`/products/apps/${this.context.currentApp.slug}/metrics/overview`}
          >
            Go Back
          </LinkToBack>
        </Toolbar>
        <PreLoader loading={this.state.loading}>
          <div className={styles.holder}>

            <Fieldset legend='Usage Details' description={''}>
              <div className={styles.engines}>
                { this.renderEngine() }

                <div className={[stylesBilling.totalPriceHolder, stylesBilling.engineDetails].join(' ')}>
                  <div className={stylesBilling.totalPrice}>
                    <label>Total Price<span className={stylesBilling.starRed}>*</span><span className={stylesEngine.starBlue}>*</span></label>
                    <div className={stylesBilling.usagePrice}>
                      <em>$</em>{p[0]}<span>.{p[1]}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className={stylesEngine.legend}>
                <p><span className={stylesEngine.starRed}>*</span> Prices exclude VAT</p>
                <p>
                  <span className={stylesEngine.starBlue}>*</span>
                  SashiDo offers <a href="https://blog.sashido.io/power-up-with-sashidos-brand-new-engine-feature/#discountsandbonuses" target="blank">Sustained use Discounts</a>. These discounts are auto-applied at the end of each billing cycle based on sustained Engine resources usage per app.
                </p>
              </div>

            </Fieldset>

          </div>
        </PreLoader>
      </div>
    );
  }
}
